module.exports = __webpack_public_path__ + "img/Group 5@2x.1464f6c1.png";